import { useTasaStore } from './store';
import { useShallow } from 'zustand/react/shallow';
import { precioVenta as _precioVenta, calcularPrecios as _calcularPrecios, esPrecioCalculado } from './precios';

/**
 * Hook: devuelve la configuración de precios (tasas + márgenes) suscrita a cambios.
 * Usa shallow comparison para no re-renderizar si los valores no cambiaron.
 */
export function useConfigPrecios() {
  return useTasaStore(
    useShallow(s => ({
      tasaCambio:       s.tasa,
      tasaInterna:      s.tasaInterna,
      margenCasheaBajo: s.margenCasheaBajo,
      margenCasheaAlto: s.margenCasheaAlto,
      umbralCashea:     s.umbralCashea,
      margenKrece:      s.margenKrece,
    }))
  );
}

/**
 * Hook: devuelve el precio final del producto (USD) reaccionando a cambios de config.
 */
export function usePrecioVenta(producto) {
  const config = useConfigPrecios();
  return _precioVenta(producto, config);
}

/**
 * Hook: devuelve todos los precios derivados (Cashea, Krece, Bs.) o null.
 */
export function usePreciosCompletos(producto) {
  const config = useConfigPrecios();
  if (!producto) return null;
  // Si no tiene costoUSD pero sí precio manual, devolvemos sólo el manual
  if (!producto.costoUSD && producto.precio) {
    return {
      casheaUSD: producto.precio,
      casheaBs:  config.tasaCambio ? producto.precio * config.tasaCambio : null,
      esManual: true,
    };
  }
  const p = _calcularPrecios(producto, config);
  return p ? { ...p, esManual: false } : null;
}

// Re-exports para conveniencia
export { esPrecioCalculado };
